export class AccountAlreadyActiveError extends Error {
  constructor() {
    super(`External user already has an active account`);
  }
}
